module.exports = __webpack_public_path__ + "static/media/Boston_Bruins.9f76a0e3.svg";